import Autocomplete from "@tarekraafat/autocomplete.js";
import "@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css";

class PlacesAutocomplete extends Autocomplete {


  constructor(config) {
    config.data = {
      src: async (input) => {
        try {
          const {data: {data} = {}} = await axios.post(config.suggestionApiUrl, {input});
          return data;
        } catch (error) {
          return error;
        }
      },
      keys: ["description"]
    };
    config.resultsList = {
      element: (list, data) => {
        if (!data.results.length) {
          const message = document.createElement("div");
          message.setAttribute("class", "no_result");
          message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
          list.prepend(message);
        }
      },
      noResults: true,
    };
    config.resultItem = {highlight: false};
    config.events = {
      input: {
        selection: async (event, cb) => {
          let {detail: {selection: {value}}} = event;
          let {description, place_id} = value;
          event.target.value = description;

          try {
            const {data} = await axios.post(config.infoApiUrl, {place_id});
            this.googleAutocomplete = data;
          } catch (error) {
            console.log({error});
          }

        }
      }
    };
    config.debounce = config.debounce ?? 700;

    super(config);
  }


}

export default PlacesAutocomplete;
